import type { ComponentTemplatesRouter } from "replo-publisher-v1/src/trpc/routers/componentTemplates";

import { createTrpcRouterConfig } from "@v2/trpc/config";
import { getNamespacedQueryClient } from "@v2/trpc/trpc";

const {
  router: componentTemplatesRouter,
  client: componentTemplatesClient,
  utils: componentTemplatesUtils,
  options: componentTemplatesOptions,
} = createTrpcRouterConfig<ComponentTemplatesRouter>({
  path: "componentTemplates",
  queryClient: getNamespacedQueryClient("componentTemplates"),
});

export {
  componentTemplatesClient,
  componentTemplatesRouter,
  componentTemplatesUtils,
  componentTemplatesOptions,
};
